import React from 'react';
import styled from 'styled-components';
import HtmlToReact from 'html-to-react';

const YoutubeVideoWrapper = styled.div`
  video {
    display: block;
    margin: 0 auto;
  }
`;

/*
  These are the types of Youtube urls supported:
  http://www.youtube.com/watch?v=0zM3nApSvMg&feature=feedrec_grec_index
  http://www.youtube.com/user/IngridMichaelsonVEVO#p/a/u/1/QdK8U-VIH_o
  http://www.youtube.com/v/0zM3nApSvMg?fs=1&amp;hl=en_US&amp;rel=0
  http://www.youtube.com/watch?v=0zM3nApSvMg#t=0m10s
  http://www.youtube.com/embed/0zM3nApSvMg?rel=0
  http://www.youtube.com/watch?v=0zM3nApSvMg
  http://youtu.be/0zM3nApSvMg
*/

function getYoutubeVideoId(videoUrlString) {
  var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
  var match = videoUrlString.match(regExp);
  const youtubeVideoId = (match&&match[7].length==11)? match[7] : videoUrlString;

  return youtubeVideoId;
}

function YoutubeVideo({ input }) {
  const { primary } = input;
  const videoUrl = primary.youtube_url.url;
  // const youtubeVideoId = getYoutubeVideoId(videoUrl.url);

  return (
    <YoutubeVideoWrapper>
      <video
        width="700"
        height="400"
        controls
        preload='auto'
        >
          <source src={`${videoUrl}`} type="video/mp4"></source>
          Your browser does not support this control, please upgrade your browser!
      </video>
    </YoutubeVideoWrapper>
  );
}

export { YoutubeVideo };
